import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  subHeader: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    maxWidth: 900,
  },
}));

export default function SubHeader(props) {
  const classes = useStyles();
  const { text, width = 900 } = props;

  return (
    <Typography
      variant="subtitle1"
      align="center"
      className={classes.subHeader}
      style={{ width }}
    >
      {text}
    </Typography>
  );
}
